'use strict'

/**
 * 列フィルタバー（項目名検索 / 設定済のみ / 未設定のみ / フィルターリセット）。 ストアから filters.searchText / checkedSet / checkedUnset を直接購読し、行フィルタ候補（派生値）と
 * onFilterChange を props で受け取る。
 *
 * React.memo + スライス購読により、テーブルのスクロールやモード変更では再レンダーされない。
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useDashboardMatrixSelector } from '../extra/store'

/**
 * @param {{
 *   rowFilterOptions: { major: string[]; middle: string[]; dashboard: string[]; graph: string[] }
 *   onFilterChange: (payload: object) => void
 * }} props
 * @returns {JSX.Element}
 */
function MatrixFilters({ rowFilterOptions, onFilterChange }) {
  const searchText = useDashboardMatrixSelector((s) => s.filters.searchText)
  const checkedSet = useDashboardMatrixSelector((s) => s.filters.checkedSet)
  const checkedUnset = useDashboardMatrixSelector((s) => s.filters.checkedUnset)

  return (
    <div className="filters flex flex-wrap gap-2.5 items-center">
      <div className="form-control">
        <input
          type="text"
          placeholder="項目名で検索"
          value={searchText}
          onChange={(e) => onFilterChange({ searchText: e.target.value })}
          className="text-input min-w-[160px] text-left"
        />
      </div>
      <label className="cb-group flex items-center gap-1 text-xs text-gray-700">
        <input
          type="checkbox"
          checked={checkedSet}
          onChange={(e) =>
            onFilterChange({
              checkedSet: e.target.checked,
              checkedUnset: e.target.checked ? false : checkedUnset
            })
          }
        />
        設定済の項目のみ
      </label>
      <label className="cb-group flex items-center gap-1 text-xs text-gray-700">
        <input
          type="checkbox"
          checked={checkedUnset}
          onChange={(e) =>
            onFilterChange({
              checkedSet: e.target.checked ? false : checkedSet,
              checkedUnset: e.target.checked
            })
          }
        />
        未設定の項目のみ
      </label>
      <button
        type="button"
        className="footer-btn button_base py-1.5 px-2.5 text-sm rounded-md border border-[#d6dbe8] bg-white text-gray-700 hover:bg-gray-100 active:bg-gray-200 transition-colors cursor-pointer"
        onClick={() =>
          onFilterChange({
            searchText: '',
            checkedSet: false,
            checkedUnset: false,
            rowFilters: {
              major: [...rowFilterOptions.major],
              middle: [...rowFilterOptions.middle],
              dashboard: [...rowFilterOptions.dashboard],
              graph: [...rowFilterOptions.graph],
              referable: 'all'
            }
          })
        }
      >
        フィルターリセット
      </button>
    </div>
  )
}

MatrixFilters.propTypes = {
  rowFilterOptions: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired
}

export default React.memo(MatrixFilters)
